import 'rxjs/add/operator/take';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LOCAL_VAR, STATES } from '@app/core/constants';
import { DateTime } from 'luxon';
import { CustomerService } from '@app/core/service/customer.service';
import { environment } from '../../../environments/environment';
import { finalize, tap, map, switchMap, distinctUntilChanged, debounceTime, catchError, filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from '@app/core';
import { of as observableOf, Observable, Subject, merge, of } from 'rxjs';
import {NgbTypeaheadConfig} from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { matchValidation } from '@app/core';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  providers: [NgbTypeaheadConfig] 
})
export class SignupComponent implements OnInit {
  signupForm: FormGroup;
  isLoading = false;
  queryParams: any;
  states: any = STATES;
  roles: string[] = ['Customer']
  dealersList: [{name: 'DOWC', _id: '0'  }];
  usertypes = [{ name: 'Selling Dealer', val: 'selling_dealer' }, { name: 'Repair Facility', val: 'repair_facility' }, { name: 'Contract Holder', val: 'contract_holder' }];
  regStatus = false;
  pwdError = '';
  appname = environment.name;
  applogo = environment.logo;
  logo = environment.logo;
  fileClaim = environment.fileClaim;
  
  @ViewChild('instance') instance: any;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();
  //formatter = (result: string) => result.toUpperCase();
  dealers = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => (term.length < 3 ? [] : this.dealersList.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)))
    );
    formatter = (x: { name: string }) => x.name;


  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private customerService: CustomerService,
    private toastrService: ToastrService,
    public utilService: UtilService,
    private authenticationService: AuthenticationService,
    config: NgbTypeaheadConfig,
  ) {
    this.route.queryParams.pipe().subscribe(params => {
      this.queryParams = params;
    });
    config.editable = false;
    this.createForm();
    
  }

  ngOnInit() { 
    var domainconfig = JSON.parse(localStorage.getItem(LOCAL_VAR.domainconfig));
    this.applogo = "assets/images/dowc-logo-green-bg.jpg";
    this.logo = "assets/images/dowc-logo.png";
    if (domainconfig) {
      if (domainconfig.appLogo) {
        this.applogo = domainconfig.appLogo;
      }
      if (domainconfig.appLogo) {
        this.logo = domainconfig.appLogo;
      }
      if (domainconfig.appName) {
        this.appname = domainconfig.appName;
      }
    } 
    this.getDealers(); 
    this.utilService.clearMissedError();
  }

  ngAfterViewInit() {
    this.utilService.updateDomainCss();
    
    setTimeout(() => {
      this.removeValidator();
    }, 500);
  }

 /*  signup() {
    this.isLoading = true;
    if (!this.queryParams.invitationCode) {
      this.signupForm.removeControl('invitationCode');
    }
  } */

  private createForm() {
    this.signupForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      address: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      dealer: [''],
      dealerName: [''],
      password: ['', [
        Validators.required,
        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-])[A-Za-z0-9\d$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-].{7,}'
        )]
      ],
      cPassword: ['', [
        Validators.required,
        Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-])[A-Za-z0-9\d$#@^$!%*?&()_<>+=?:;"\',./|<>{}\\\\-].{7,}'
        )]],
      zipcode: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(5)
        ])
      ],
      phone: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(12)
        ])
      ],
      email: ['', [Validators.required, Validators.pattern(/^(\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)]],
      birthDate: [''],
      noDealer:[false],
      usertype: ['', [Validators.required]],
      reimbursement: [0],
    },
    { validator: matchValidation('password', 'cPassword') });
  }
  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     this.removeValidator();
  //   }, 500);
  // }

  removeValidator() {
    this.signupForm.get('dealer').clearValidators();
    this.signupForm.get('dealer').updateValueAndValidity();
    this.signupForm.get('birthDate').clearValidators();
    this.signupForm.get('birthDate').updateValueAndValidity();
  }

  changeValidator(){
    if(this.signupForm.get('usertype').value && this.signupForm.get('usertype').value=='contract_holder'){
      this.signupForm.get('reimbursement').setValidators([Validators.required]);
    } else {
      this.signupForm.get('reimbursement').clearValidators();
    }
    this.signupForm.get('reimbursement').updateValueAndValidity();

  }

  getDealers() {
    this.customerService.getDealers()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        if (response && response.records) {
          this.dealersList = response.records;
        }
      });
  }

  signup() {
    this.isLoading = true;
    const payload = this.signupForm.value;
    payload.birthDate = payload.birthDate
      ? DateTime.fromObject(payload.birthDate).toISO()
      : '';
    if (payload.password === payload.password){
      
    } else {
      this.pwdError = '';
    }
    payload.dealer = payload.dealer ? payload.dealer : '';
    
    this.authenticationService
      .signup(this.signupForm.value) 
      .pipe(
        finalize(() => {
          //this.signupForm.markAsPristine();  //to reset the form
          this.isLoading = false;
        })
      )
      .subscribe((response: any) => {
        this.toastrService.info('Account created Successfully');
        this.regStatus = true;
        // this.router.navigate(['/login']);
      });
  }
}
